import { connect } from 'react-redux';
import * as R from 'ramda';

// Component
import MainPanel from './MainPanel';

// Functions
import {
  fetchBolHistory,
  fetchLocationDetails,
  fetchLocationLoadTimes,
  getItem,
  setActiveTab,
  setMobileDrawerOpen,
  setMobileFilterDrawerOpen,
} from '../store/rackWaitTimesSlice';

const mapState = R.applySpec({
  activeLocation: getItem('activeLocation'),
  activeTab: getItem('activeTab'),
  bolDate: getItem('bolDate'),
  lastFetchTime: getItem('lastFetchTime'),
  locationDetailsPending: getItem('locationDetailsPending'),
  locationLoadTimesPending: getItem('locationLoadTimesPending'),
  locationsPending: getItem('locationsPending'),
  selectedAffiliate: getItem('selectedAffiliate'),
});

const mapDispatchToProps = {
  fetchBolHistory,
  fetchLocationDetails,
  fetchLocationLoadTimes,
  setActiveTab,
  setMobileDrawerOpen,
  setMobileFilterDrawerOpen,
};

export default connect(mapState, mapDispatchToProps)(MainPanel);
